var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5455 16.97C29.8885 19.3115 29.8885 23.111 27.5455 25.454L19.06 33.9395C18.475 34.5245 17.524 34.5245 16.939 33.9395L8.45354 25.454C6.11054 23.111 6.11054 19.3115 8.45354 16.9685C10.7965 14.6255 14.596 14.6255 16.939 16.9685L17.998 18.029L19.06 16.9685C21.403 14.6255 25.2025 14.6255 27.5455 16.9685V16.97ZM10.5745 19.088C9.40454 20.2595 9.40454 22.16 10.5745 23.3315L17.9995 30.7565L25.4245 23.3315C26.5945 22.16 26.5945 20.2595 25.4245 19.088C24.253 17.918 22.3525 17.918 21.1795 19.091L17.9965 22.268L14.8165 19.088C13.6465 17.918 11.746 17.918 10.5745 19.088ZM17.9995 2C21.3145 2 23.9995 4.685 23.9995 8C23.9995 11.315 21.3145 14 17.9995 14C14.6845 14 11.9995 11.315 11.9995 8C11.9995 4.685 14.6845 2 17.9995 2ZM17.9995 5C16.342 5 14.9995 6.3425 14.9995 8C14.9995 9.6575 16.342 11 17.9995 11C19.657 11 20.9995 9.6575 20.9995 8C20.9995 6.3425 19.657 5 17.9995 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.63c0b7c19afce70c3055b891e0854d0e.svg";
export { ForwardRef as ReactComponent };